// // field-validations.js
// // ==================================================================================
// // FIELD-LEVEL VALIDATION RULES - Platform Standard Validations
// // ==================================================================================
// // This file contains immutable, business-friendly validation rules for all field types.
// // Each validation includes user-friendly error messages that non-technical users can understand.
// // These rules are automatically applied when users select field types in the form builder.
// // ==================================================================================

// const FIELD_VALIDATIONS = {
  
//   // ==================================================================================
//   // TEXT INPUT FIELDS
//   // ==================================================================================
  
//   textOnly: {
//     value: "textOnly",
//     label: "Text Only",
//     fieldType: "text",
//     icon: "📝",
//     tooltip: "Only letters - no numbers or special characters allowed",
//     autoValidations: {
//       pattern: "^[a-zA-Z\\s'-]+$",
//       trim: true
//     },
//     errorMessages: {
//       pattern: "Only letters, spaces, hyphens and apostrophes are allowed",
//       required: "This field is required"
//     },
//     placeholder: "Enter text here"
//   },

//   emailOnly: {
//     value: "emailOnly",
//     label: "Email Only",
//     fieldType: "email",
//     icon: "📧",
//     tooltip: "abc@def.ghk",
//     autoValidations: {
//       pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
//       maxLength: 254,
//       trim: true,
//       toLowerCase: true
//     },
//     errorMessages: {
//       pattern: "Please enter a valid email address (e.g., name@example.com)",
//       maxLength: "Email address is too long",
//       required: "Email address is required"
//     },
//     placeholder: "name@example.com"
//   },

//   passwordOnly: {
//     value: "passwordOnly",
//     label: "Password Only",
//     fieldType: "password",
//     icon: "🔒",
//     tooltip: "Password policies",
//     linkText: "View policies",
//     autoValidations: {
//       minLength: 8,
//       pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d@$!%*?&]{8,}$"
//     },
//     errorMessages: {
//       pattern: "Password must contain uppercase, lowercase and at least one number",
//       minLength: "Password must be at least 8 characters long",
//       required: "Password is required"
//     },
//     placeholder: "Enter strong password"
//   },

//   phoneOnly: {
//     value: "phoneOnly",
//     label: "Phone Only",
//     fieldType: "tel",
//     icon: "📱",
//     tooltip: "10 digits, pattern based on country",
//     linkText: "Select country",
//     autoValidations: {
//       pattern: "^[0-9]{10}$",
//       length: 10,
//       trim: true
//     },
//     errorMessages: {
//       pattern: "Phone number must be exactly 10 digits",
//       length: "Phone number must be 10 digits",
//       required: "Phone number is required"
//     },
//     placeholder: "9876543210",
//     formatting: {
//       mask: "9999999999",
//       stripNonNumeric: true
//     }
//   },

//   numberOnly: {
//     value: "numberOnly",
//     label: "Number Only",
//     fieldType: "number",
//     icon: "🔢",
//     tooltip: "Only whole numbers (e.g., 100, 250, 1500)",
//     autoValidations: {
//       pattern: "^-?\\d+$",
//       step: 1
//     },
//     errorMessages: {
//       pattern: "Please enter a whole number without decimals",
//       required: "Number is required"
//     },
//     placeholder: "100"
//   },

//   decimalOnly: {
//     value: "decimalOnly",
//     label: "Decimal Only",
//     fieldType: "number",
//     icon: "🔢",
//     tooltip: "Numbers with decimals (e.g., 25.50, 100.75) - precision configurable",
//     autoValidations: {
//       pattern: "^\\d*\\.?\\d+$",
//       step: 0.01
//     },
//     errorMessages: {
//       pattern: "Please enter a valid decimal number",
//       required: "Decimal number is required"
//     },
//     placeholder: "25.50"
//   },

//   currencyOnly: {
//     value: "currencyOnly",
//     label: "Currency Only",
//     fieldType: "number",
//     icon: "💰",
//     tooltip: "Amount with currency symbol by country (e.g., $100.00, ₹250.50) - precision configurable",
//     linkText: "Select country",
//     autoValidations: {
//       pattern: "^\\d+(\\.\\d{1,2})?$",
//       min: 0,
//       max: 999999999.99,
//       step: 0.01
//     },
//     errorMessages: {
//       pattern: "Please enter a valid amount (e.g., 100 or 100.50)",
//       min: "Amount cannot be negative",
//       max: "Amount is too large",
//       required: "Amount is required"
//     },
//     placeholder: "100.00",
//     formatting: {
//       prefix: "$",
//       decimalPlaces: 2
//     }
//   },

//   weightOnly: {
//     value: "weightOnly",
//     label: "Weight Only",
//     fieldType: "number",
//     icon: "⚖️",
//     tooltip: "Weight with units (e.g., 5.5 kg, 10.2 lbs, 250 gms) - precision configurable",
//     linkText: "Select unit",
//     autoValidations: {
//       pattern: "^\\d*\\.?\\d+$",
//       min: 0,
//       step: 0.01
//     },
//     errorMessages: {
//       pattern: "Please enter a valid weight",
//       min: "Weight cannot be negative",
//       required: "Weight is required"
//     },
//     placeholder: "5.5",
//     formatting: {
//       suffix: " kg"
//     }
//   },

//   textarea: {
//     value: "textarea",
//     label: "Textarea",
//     fieldType: "textarea",
//     icon: "📄",
//     tooltip: "Multi-line text input - Min: 10 chars, Max: 256 chars",
//     autoValidations: {
//       minLength: 10,
//       maxLength: 256,
//       trim: true
//     },
//     errorMessages: {
//       minLength: "Text must be at least 10 characters",
//       maxLength: "Text cannot exceed 256 characters",
//       required: "This field is required"
//     },
//     placeholder: "Enter your text here...",
//     rows: 4
//   },

//   dateOnly: {
//     value: "dateOnly",
//     label: "Date Only",
//     fieldType: "date",
//     icon: "📅",
//     tooltip: "Date only",
//     linkText: "Choose format",
//     autoValidations: {
//       format: "YYYY-MM-DD"
//     },
//     errorMessages: {
//       format: "Please enter a valid date",
//       required: "Date is required"
//     },
//     placeholder: "Select date"
//   },

//   dateTime: {
//     value: "dateTime",
//     label: "Date & Time",
//     fieldType: "datetime-local",
//     icon: "🕐",
//     tooltip: "Date and time till minutes/seconds",
//     linkText: "Choose format",
//     autoValidations: {
//       format: "YYYY-MM-DDTHH:mm"
//     },
//     errorMessages: {
//       format: "Please enter a valid date and time",
//       required: "Date and time is required"
//     },
//     placeholder: "Select date and time"
//   },

//   checkbox: {
//     value: "checkbox",
//     label: "Checkbox",
//     fieldType: "checkbox",
//     icon: "☑️",
//     tooltip: "Yes/No or True/False or Multi-select",
//     linkText: "Configure",
//     autoValidations: {},
//     errorMessages: {
//       required: "Please check this box"
//     }
//   },

//   radio: {
//     value: "radio",
//     label: "Radio Group",
//     fieldType: "radio",
//     icon: "🔘",
//     tooltip: "Choose any one option",
//     linkText: "Add options",
//     autoValidations: {},
//     errorMessages: {
//       required: "Please select an option"
//     }
//   },

//   dropdown: {
//     value: "dropdown",
//     label: "Dropdown",
//     fieldType: "dropdown",
//     icon: "▼",
//     tooltip: "Choose one from list",
//     linkText: "Add options",
//     autoValidations: {},
//     errorMessages: {
//       required: "Please select an option"
//     }
//   },

//   file: {
//     value: "file",
//     label: "File Upload",
//     fieldType: "file",
//     icon: "📎",
//     tooltip: "Upload files - only img, only docx, only pdf, etc.",
//     linkText: "Configure file types",
//     description: "Description mandatory",
//     autoValidations: {
//       maxSize: 5242880, // 5MB
//       allowedTypes: []
//     },
//     errorMessages: {
//       maxSize: "File size must be less than 5MB",
//       allowedTypes: "File type not allowed",
//       required: "Please upload a file"
//     }
//   }

// };

// // Export as array for dropdown
// export const SMART_FIELD_TYPES = Object.values(FIELD_VALIDATIONS);

// // Export individual validations
// export default FIELD_VALIDATIONS;
// field-validations.js
// ==================================================================================
// FIELD-LEVEL VALIDATION RULES - Platform Standard Validations
// ==================================================================================
// This file contains all field type definitions with validation rules
// Prefix: mudumbai_ to avoid conflicts with HTML5 default validations
// Each field type has: label, tooltip, validation rules, error messages
// These are auto-applied when user selects field type in form builder
// ==================================================================================

const FIELD_VALIDATIONS = {
  
  // ==================================================================================
  // TEXT INPUT FIELDS
  // ==================================================================================
  
  mudumbai_textOnly: {
    value: "mudumbai_textOnly",
    label: "Text Only", // Shows in dropdown
    fieldType: "text", // HTML input type
    icon: "📝",
    tooltip: "Only letters - no numbers or special characters allowed",
    autoValidations: {
      pattern: "^[a-zA-Z\\s'-]+$", // Regex pattern for validation
      trim: true, // Auto-trim whitespace
      minLength: 2,
      maxLength: 100
    },
    errorMessages: {
      pattern: "Only letters, spaces, hyphens and apostrophes are allowed",
      minLength: "Must be at least 2 characters",
      maxLength: "Cannot exceed 100 characters",
      required: "This field is required"
    },
    placeholder: "Enter text here"
  },

  mudumbai_emailOnly: {
    value: "mudumbai_emailOnly",
    label: "Email Only",
    fieldType: "email",
    icon: "📧",
    tooltip: "Valid email format: abc@def.ghk",
    autoValidations: {
      pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
      maxLength: 254,
      trim: true,
      toLowerCase: true
    },
    errorMessages: {
      pattern: "Please enter a valid email address (e.g., name@example.com)",
      maxLength: "Email address is too long",
      required: "Email address is required"
    },
    placeholder: "name@example.com"
  },

  mudumbai_passwordOnly: {
    value: "mudumbai_passwordOnly",
    label: "Password Only",
    fieldType: "password",
    icon: "🔒",
    tooltip: "Minimum 8 characters with uppercase, lowercase and number",
    autoValidations: {
      minLength: 8,
      pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d@$!%*?&]{8,}$"
    },
    errorMessages: {
      pattern: "Password must contain uppercase, lowercase and at least one number",
      minLength: "Password must be at least 8 characters long",
      required: "Password is required"
    },
    placeholder: "Enter password"
  },

  mudumbai_phoneOnly: {
    value: "mudumbai_phoneOnly",
    label: "Phone Only",
    fieldType: "tel",
    icon: "📱",
    tooltip: "10 digits only (e.g., 9876543210)",
    autoValidations: {
      pattern: "^[0-9]{10}$",
      length: 10,
      trim: true
    },
    errorMessages: {
      pattern: "Phone number must be exactly 10 digits",
      length: "Phone number must be 10 digits",
      required: "Phone number is required"
    },
    placeholder: "9876543210",
    formatting: {
      mask: "9999999999",
      stripNonNumeric: true
    }
  },

  mudumbai_numberOnly: {
    value: "mudumbai_numberOnly",
    label: "Number Only",
    fieldType: "number",
    icon: "🔢",
    tooltip: "Whole numbers only (e.g., 100, 250, 1500)",
    autoValidations: {
      pattern: "^-?\\d+$",
      step: 1
    },
    errorMessages: {
      pattern: "Please enter a whole number without decimals",
      required: "Number is required"
    },
    placeholder: "100"
  },

  mudumbai_decimalOnly: {
    value: "mudumbai_decimalOnly",
    label: "Decimal Only",
    fieldType: "number",
    icon: "🔢",
    tooltip: "Numbers with decimals (e.g., 25.50, 100.75)",
    autoValidations: {
      pattern: "^\\d*\\.?\\d+$",
      step: 0.01
    },
    errorMessages: {
      pattern: "Please enter a valid decimal number",
      required: "Decimal number is required"
    },
    placeholder: "25.50"
  },

  mudumbai_currencyOnly: {
    value: "mudumbai_currencyOnly",
    label: "Currency Only",
    fieldType: "number",
    icon: "💰",
    tooltip: "Currency amount (e.g., $100.00, ₹250.50)",
    autoValidations: {
      pattern: "^\\d+(\\.\\d{1,2})?$",
      min: 0,
      max: 999999999.99,
      step: 0.01
    },
    errorMessages: {
      pattern: "Please enter a valid amount (e.g., 100 or 100.50)",
      min: "Amount cannot be negative",
      max: "Amount is too large",
      required: "Amount is required"
    },
    placeholder: "100.00",
    formatting: {
      prefix: "$",
      decimalPlaces: 2
    }
  },

  mudumbai_weightOnly: {
    value: "mudumbai_weightOnly",
    label: "Weight Only",
    fieldType: "number",
    icon: "⚖️",
    tooltip: "Weight with units (e.g., 5.5 kg, 10.2 lbs, 250 gms)",
    autoValidations: {
      pattern: "^\\d*\\.?\\d+$",
      min: 0,
      step: 0.01
    },
    errorMessages: {
      pattern: "Please enter a valid weight",
      min: "Weight cannot be negative",
      required: "Weight is required"
    },
    placeholder: "5.5",
    formatting: {
      suffix: " kg"
    }
  },

  mudumbai_textMultiline: {
    value: "mudumbai_textMultiline",
    label: "Text Multiline",
    fieldType: "textarea",
    icon: "📄",
    tooltip: "Multiple lines of text (Min: 10 chars, Max: 1000 chars)",
    autoValidations: {
      minLength: 10,
      maxLength: 1000,
      trim: true
    },
    errorMessages: {
      minLength: "Text must be at least 10 characters",
      maxLength: "Text cannot exceed 1000 characters",
      required: "This field is required"
    },
    placeholder: "Enter your text here...",
    rows: 4
  },

  mudumbai_dateOnly: {
    value: "mudumbai_dateOnly",
    label: "Date Only",
    fieldType: "date",
    icon: "📅",
    tooltip: "Select date from calendar",
    autoValidations: {
      format: "YYYY-MM-DD"
    },
    errorMessages: {
      format: "Please enter a valid date",
      required: "Date is required"
    },
    placeholder: "Select date"
  },

  mudumbai_dateTime: {
    value: "mudumbai_dateTime",
    label: "Date & Time",
    fieldType: "datetime-local",
    icon: "🕐",
    tooltip: "Date and time selection",
    autoValidations: {
      format: "YYYY-MM-DDTHH:mm"
    },
    errorMessages: {
      format: "Please enter a valid date and time",
      required: "Date and time is required"
    },
    placeholder: "Select date and time"
  },

  mudumbai_checkbox: {
    value: "mudumbai_checkbox",
    label: "Checkbox",
    fieldType: "checkbox",
    icon: "☑️",
    tooltip: "Single checkbox (Yes/No or True/False)",
    autoValidations: {},
    errorMessages: {
      required: "Please check this box"
    }
  },

  mudumbai_dropdown: {
    value: "mudumbai_dropdown",
    label: "Dropdown",
    fieldType: "dropdown",
    icon: "▼",
    tooltip: "Select one option from list",
    autoValidations: {},
    errorMessages: {
      required: "Please select an option"
    }
  },

  mudumbai_file: {
    value: "mudumbai_file",
    label: "File Upload",
    fieldType: "file",
    icon: "📎",
    tooltip: "Upload files (images, documents, PDFs)",
    autoValidations: {
      maxSize: 5242880, // 5MB in bytes
      allowedTypes: []
    },
    errorMessages: {
      maxSize: "File size must be less than 5MB",
      allowedTypes: "File type not allowed",
      required: "Please upload a file"
    }
  }

};

// ==================================================================================
// EXPORT AS ARRAY FOR DROPDOWN
// ==================================================================================
export const SMART_FIELD_TYPES = Object.values(FIELD_VALIDATIONS);

// ==================================================================================
// EXPORT DEFAULT OBJECT FOR LOOKUPS
// ==================================================================================
export default FIELD_VALIDATIONS;